import { BehaviorSubject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'

class CreateBloc {
    createRepository = new CreateRepository()
    
    createChannel = new BehaviorSubject({
        status: apiResponse.INITIAL,
        data: []
    })

    async fetchCreate(data) {
        this.createChannel.next({
            status: apiResponse.LOADING,
            data: []
        })

        try {
            const response = await this.createRepository.fetchCreate(data)
            this.createChannel.next({
                status: apiResponse.COMPLETED,
                data: response
            })
        } catch (error) {
            this.createChannel.next({
                status: apiResponse.ERROR,
                data: error
            })
        }
    }
}

export default CreateBloc
